import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type ShiftVersionHistory from 'modules/attendance/store/models/ShiftVersionHistory'

import HistoryPopover from './HistoryPopover'

interface ShiftPopoverProps {
  histories: ShiftVersionHistory[]
}

const ShiftPopover = ({ histories }: ShiftPopoverProps) => {
  const changes = [...new Set(histories.flatMap((history) => history.changes))]

  if (changes.length > 0) {
    return <HistoryPopover changes={changes} />
  }

  return <Box width="s32"></Box>
}

export default observer(ShiftPopover)
